import { useState } from 'react';
import LandingPage from '../../components/hanHwa/LandingPage';
import CategorySelectPage from '../../components/hanHwa/CategorySelectPage';
import VideoPage from '../../components/hanHwa/VideoPage';

type Category = 'sleep' | 'stress' | 'clear';

export default function HanwaPromotion() {
  const [currentStep, setCurrentStep] = useState(0);
  const [category, setCategory] = useState<Category | null>(null);

  return (
    <div className="min-h-screen bg-background">
      {currentStep === 0 && <LandingPage onNext={() => setCurrentStep(1)} />}

      {currentStep === 1 && (
        <CategorySelectPage
          onNext={(value) => {
            setCategory(value);
            setCurrentStep(2);
          }}
        />
      )}

      {currentStep === 2 && category && <VideoPage category={category} />}
    </div>
  );
}
